import { StarIcon } from 'lucide-react';
type Testimonial = {
  name: string;
  role: string;
  image: string;
  quote: string;
};
const TESTIMONIALS: Testimonial[] = [{
  name: 'Carlos Medina',
  role: 'Herrero · Córdoba, Argentina',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b91e4b01-804e-421b-99a1-b68ab7026876.jpg',
  quote: 'Tenía la soldadora hace dos años y siempre adivinaba el amperaje. Con las tablas del Sistema Maestro configuro en segundos y mis cordones salen parejos. Dejé de desperdiciar electrodos.'
}, {
  name: 'Nahuel Ríos',
  role: 'Aficionado · Rosario, Argentina',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/9a79ac13-98ea-4816-b34c-eda322dcdc99.jpg',
  quote: 'Aprendía en YouTube pero cada video decía algo distinto. Acá está todo ordenado paso a paso. Ya fabriqué una parrilla y una reja para mi casa sin depender de nadie.'
}, {
  name: 'Diego Fernández',
  role: 'Soldador · Mendoza, Argentina',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/f53c587e-2861-4d74-9217-491ee91eb4f6.jpg',
  quote: 'El manual de diagnóstico de errores es oro puro. Ahora reviso el cordón y sé al toque qué corregir. Empecé a cobrar trabajos con el bono de costos y ya recuperé la inversión mil veces.'
}];
export function Testimonials() {
  return <div className="grid gap-4" data-id="element-207" data-mp="zwg08fxsu2ne">
      {TESTIMONIALS.map(t => <figure key={t.name} className="rounded-2xl border border-white/10 bg-[#16161a] p-5" data-id="element-208" data-mp="zx7qrccjha6t">
          <div className="mb-3 flex items-center gap-3" data-id="element-209" data-mp="q6mn3ai0dfh1">
            <img src={t.image} alt={`Foto de ${t.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-amber-500/60" loading="lazy" data-id="element-210" data-mp="q63eike903fo" />
            <div className="min-w-0" data-id="element-211" data-mp="1it7do8qntnjj">
              <figcaption className="font-cond text-base font-semibold text-white" data-id="element-212" data-mp="1nmk2aivc9uca">
                {t.name}
              </figcaption>
              <p className="truncate text-xs text-neutral-400" data-id="element-213" data-mp="1xhh6jwvhpdm7">{t.role}</p>
              <div className="mt-0.5 flex gap-0.5" data-id="element-214" data-mp="1sjz5strmm4pa">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" data-id="element-215" data-mp="1ofzquflzvdy1" data-mpi={i} />)}
              </div>
            </div>
          </div>
          <blockquote className="text-sm leading-relaxed text-neutral-300" data-id="element-216" data-mp="1ekg007maf5g5">
            “{t.quote}”
          </blockquote>
        </figure>)}
    </div>;
}